__turbopack_context__.v({
  "group": "AlphaServiceList-module-scss-module__i2tnWq__group",
  "heading": "AlphaServiceList-module-scss-module__i2tnWq__heading",
  "lists": "AlphaServiceList-module-scss-module__i2tnWq__lists",
  "main": "AlphaServiceList-module-scss-module__i2tnWq__main",
});
